import {
  MainFormsOC,
  MainFormsForeignOC,
  MainFormsAuditor,
  MainFormsForeignAuditor,
  MainFormsSupplier,
  MainFormsForeignSupplier,
  LoginPage1,
  MapPage,
  Reports
} from '../pages';
import { AppTrackPageSupplier, ViewFormSupplier } from 'pages/appTrack/appTrackSupplier';
import AdminPage from 'pages/adminPanel';
import ForgotPassword from 'pages/login/forgotPassword'; //na ta grouparw otan teleiwsw - mhn ta kanw 1-1
import NewPasswordPage from 'pages/login/newPasswordPage';
import AuthErrorPage from 'pages/login/authErrorsPage';
import AlreadyLoggedPage from 'pages/login/alreadyLoggedInPage';

export const routes = [
  {
    name: 'Admin',
    path: '/admin',
    Element: AdminPage,
  },
  {
    name: 'MainForms',
    path: '/main-forms/:taskId',
    Element: MainFormsSupplier,
  },
  {
    name: 'MainFormsForeignSupplier',
    path: '/main-forms-fs/:taskId',
    Element: MainFormsForeignSupplier,
  },
  {
    name: 'MainFormsAuditor',
    path: '/main-forms-auditor/:taskId',
    Element: MainFormsAuditor,
  },
  {
    name: 'MainFormsForeignAuditor',
    path: '/main-forms-auditor-fs/:taskId',
    Element: MainFormsForeignAuditor,
  },
  {
    name: 'MainFormsOC',
    path: '/main-forms-oc/:taskId',
    Element: MainFormsOC,
  },
  {
    name: 'MainFormsForeignOC',
    path: '/main-forms-oc-fs/:taskId',
    Element: MainFormsForeignOC,
  },
  {
    name: 'MainForms',
    path: '/main-forms/:taskId/view',
    Element: MainFormsSupplier,
  },
  {
    name: 'MainFormsForeignSupplier',
    path: '/main-forms-fs/:taskId/view',
    Element: MainFormsForeignSupplier,
  },
  {
    name: 'ApptrackView',
    path: '/apptrack/:taskId',
    Element: ViewFormSupplier,
  },
{
    name: 'AppTrackPage1',
    path: 'apptrack',
    Element: AppTrackPageSupplier,
},
{
    name: 'ApptrackPage1',
    path: 'apptrack-auditor',
    Element: AppTrackPageSupplier,
},
  {
    name: 'LoginPage1',
    path: 'login',
    Element: LoginPage1,
  },
  {
    name: 'ForgotPassword',
    path: '/forgot-password',
    Element: ForgotPassword,
  },
  {
    name: 'NewPassword',
    path: '/new-password',
    Element: NewPasswordPage,
  },
  {
    name: 'AuthError',
    path: '/auth-error',
    Element: AuthErrorPage,
  },
  {
    name: 'AlreadyLogged',
    path: '/already-logged',
    Element: AlreadyLoggedPage,
  },
  {
    name: 'MapPage',
    path: '/map',
    Element: MapPage,
  },
  {
    name: 'ReportsPage',
    path: '/reports',
    Element: Reports,
  },
];
